import React from 'react';
import { Controlled as CodeMirror } from 'react-codemirror2';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
require('codemirror/mode/javascript/javascript');

const options = {
  mode: 'javascript',
  theme: 'material',
  lineNumbers: true,
  foldGutter: true
};

const JsonViewer = (props) => {
  const onChange = (editor, data, value) => {
    if (!props.readOnly) {
      props.onChangeJson(value);
    }
  };

  return (
    <div className="h-full">
      <CodeMirror
        className="h-full"
        value={props.value}
        options={options}
        onBeforeChange={onChange}
      />
    </div>
  );
};

export default JsonViewer;
